export const SALE_ENTERPRISE = {
    numOfDecimals: 2
};
